import React from 'react';

function GifIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="108"
      height="108"
      viewBox="0 0 108 108"
    >
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <path fill="#FFF" d="M0 0H108V108H0z" />
        <path
          fill="#FFF"
          fillRule="nonzero"
          d="M80.19 65.983a1.333 1.333 0 001.048-1.313V54.615h6.147c.308 0 .615-.316.615-.632 0-.227-.086-.405-.25-.514l-.01-.01-6.877-7.081c-.442-.504-1.23-.504-1.729 0l-6.945 7.14c-.202.208-.24.435-.125.702.068.237.308.375.567.375h6.148V64.71c0 .77.682 1.403 1.412 1.274z"
          transform="rotate(-90 80 56)"
        />
        <path
          fill="currentColor"
          d="M93 11a4 4 0 014 4v78a4 4 0 01-4 4H15a4 4 0 01-4-4V15a4 4 0 014-4h78zM48.55 46a1.251 1.251 0 00-.66.18 1.21 1.21 0 00-.587.864l-.045.554-.076.766-.032.417-.027.482-.024.546-.02.611c-.004.108-.006.217-.009.33A78.62 78.62 0 0047 54c0 .78.013 1.586.04 2.419l.044 1.173.056 1.16.042.697.057.731.056.612.005.038c.006.417.235.799.6 1 .199.12.428.183.66.18.152-.012.3-.049.44-.11A46.15 46.15 0 0060.56 55a1.22 1.22 0 00.44-1 1.12 1.12 0 00-.44-.94l-.052-.05-.146-.13-.319-.263-.24-.19-.397-.3-.922-.675-.224-.162a52.033 52.033 0 00-2.45-1.66 44.688 44.688 0 00-3.13-1.81A37.967 37.967 0 0049 46.1a1.384 1.384 0 00-.45-.1z"
        />
      </g>
    </svg>
  );
}

export default GifIcon;



// WEBPACK FOOTER //
// ./src/components/modules/Examples/GifPreview.js